import React from 'react';
import styled from 'styled-components';
import { StaticQuery, graphql } from 'gatsby';
import { Link } from 'gatsby';
import { slugify } from '../../utils/functions';
import { Container } from '../Layout';

const TagList = styled.ul`
  text-align: center;
  width: 100%;
  padding: 0.8rem 0;
  li,
  h5 {
    text-align: center;
    margin: auto;
    display: inline-block;
  }
  a {
    opacity: 0.8;
    padding: 0.8rem 1.2rem;
    &:hover {
      opacity: 1;
    }
  }
`;

function removeItems(tag) {
  switch (tag) {
    case 'Case Study':
    case 'case study':
    case 'Featured':
    case 'featured':
      return false;
    default:
      return true;
  }
}

const Tag = ({ label, url }) => (
  <li>
    <p
      style={{
        textTransform: 'capitalize',
        fontWeight: 700,
      }}
    >
      <Link to={url}>{label}</Link>
    </p>
  </li>
);

export const ListPortfolioTags = () => (
  <StaticQuery
    query={graphql`
      query ProjectTagListQuery {
        allPrismicClient {
          distinct(field: tags)
        }
      }
    `}
    render={data => {
      const tags = data.allPrismicClient.distinct;

      return (
        <Container>
          <TagList>
            <Tag label="All Products" url="/portfolio" />
            {tags.map(
              (tag, index) =>
                removeItems(tag) && (
                  <Tag
                    key={tag + index}
                    label={tag}
                    url={`portfolio/${slugify(tag)}`}
                  />
                )
            )}
          </TagList>
        </Container>
      );
    }}
  />
);

export default ListPortfolioTags;
